import React, { useEffect, useState } from 'react';
import legalLinks from '../../constants/legalLinks';

const COOKIE_CONSENT_STORAGE_KEY = 'mostikCookieConsentAccepted';

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);
  const [isCookieInfoOpen, setIsCookieInfoOpen] = useState(false);

  useEffect(() => {
    setIsVisible(localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY) !== 'true');
  }, []);

  const acceptCookieConsent = () => {
    localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, 'true');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <>
      <div
        className="cookie-consent"
        role="dialog"
        aria-label="Уведомление об использовании cookie"
        aria-live="polite"
      >
        <p className="cookie-consent__text">
          Мы используем файлы{' '}
          <button
            className="cookie-consent__link cookie-consent__link_button"
            type="button"
            onClick={() => setIsCookieInfoOpen(true)}
          >
            cookies
          </button>{' '}
          и сервисы аналитики (включая Яндекс Метрику) для анализа работы сайта и улучшения его
          функциональности. Продолжая использование сайта, вы даёте{' '}
          <a
            href={legalLinks.personalDataConsent}
            className="cookie-consent__link"
            target="_blank"
            rel="noreferrer"
          >
            согласие на обработку данных
          </a>{' '}
          в соответствии с{' '}
          <a
            href={legalLinks.privacyPolicy}
            className="cookie-consent__link"
            target="_blank"
            rel="noreferrer"
          >
            Политикой конфиденциальности
          </a>
          .
        </p>
        <button className="cookie-consent__button" type="button" onClick={acceptCookieConsent}>
          Принять
        </button>
      </div>

      {isCookieInfoOpen && (
        <div className="cookie-info">
          <button
            className="cookie-info__backdrop"
            type="button"
            aria-label="Закрыть условия использования cookie"
            onClick={() => setIsCookieInfoOpen(false)}
          />
          <div className="cookie-info__content" role="dialog" aria-modal="true">
            <button
              className="cookie-info__close"
              type="button"
              aria-label="Закрыть"
              onClick={() => setIsCookieInfoOpen(false)}
            >
              ×
            </button>
            <h2 className="cookie-info__title">Условия использования файлов cookie</h2>
            <div className="cookie-info__text">
              <p>
                На сайте https://lk.mostikschool.ru/ и его поддоменах (далее — Сайт) используются
                файлы cookie. Файлы cookie — это небольшие текстовые файлы, которые после просмотра
                Пользователем фрагментов Сайта сохраняются на его устройстве.
              </p>
              <p>
                Использование файлов cookie позволяет ООО «Мостик» (далее – Оператор) контролировать
                доступность Сайта, анализировать данные, а также понимать, как развивать оказываемые
                услуги.
              </p>
              <p>На Сайте используются следующие типы файлов cookie:</p>
              <ol>
                <li>
                  Технические файлы cookie - Они позволяют подсчитывать количество Пользователей
                  Сайта; определять, какие действия Пользователь совершает на Сайте (посещаемые
                  страницы, время и количество просмотренных страниц). Сбор аналитических данных
                  осуществляется через партнеров, в том числе Google Analytics, Yandex Metrika.
                </li>
                <li>
                  Файлы cookie для аутентификации - Они позволяют подсчитывать количество
                  Пользователей Сайта; определять, какие действия Пользователь совершает на Сайте
                  (посещаемые страницы, время и количество просмотренных страниц). Сбор
                  аналитических данных осуществляется через партнеров, в том числе Google Analytics,
                  Yandex Metrika.
                </li>
                <li>
                  Аналитические файлы cookie - Они позволяют подсчитывать количество Пользователей
                  Сайта; определять, какие действия Пользователь совершает на Сайте (посещаемые
                  страницы, время и количество просмотренных страниц). Сбор аналитических данных
                  осуществляется через партнеров, в том числе Google Analytics, Yandex Metrika.
                </li>
                <li>
                  Рекламные файлы cookie - Они помогают анализировать, из каких источников
                  Пользователь перешел на Сайт, а также персонализировать рекламные сообщения.
                </li>
              </ol>
              <p>
                Срок хранения файлов cookie зависит от конкретного типа, но в любом случае не
                превышает срока, необходимого для достижения целей обработки персональных данных.
              </p>
              <p>
                При посещении Сайта Оператор запрашивает согласие Пользователя на использование
                файлов cookie.
              </p>
              <p>
                Для прекращения обработки файлов cookie Пользователь может изменить настройки
                используемых браузеров на всех устройствах (компьютер, мобильные устройства).
              </p>
              <p>
                При отказе от использования файлов cookie отдельные функции Сайта могут быть
                недоступными, что повлияет на возможность использования Сайта.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
